import { render, staticRenderFns } from "./FileDetailCard.vue?vue&type=template&id=72db896a&scoped=true&"
import script from "./FileDetailCard.vue?vue&type=script&lang=js&"
export * from "./FileDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./FileDetailCard.vue?vue&type=style&index=0&id=72db896a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72db896a",
  null
  
)

export default component.exports